import React from 'react';
import { EntityAskAI } from '../common/EntityAskAI';

interface SearchAskAIProps {
  fileIds: string[];
  teamId: string;
}

const getSuggestions = () => [
  'What are in these recordings?',
  'Summarize all recordings',
  'What are the main topics?',
  'What action items were mentioned?',
  'Create a summary report',
];

export const SearchAskAI: React.FC<SearchAskAIProps> = ({
  fileIds,
  teamId,
}) => {
  return (
    <EntityAskAI
      entityName="Search Results"
      entityType="company"
      fileIds={fileIds}
      teamId={teamId}
      getSuggestions={getSuggestions}
    />
  );
};

export default SearchAskAI;
